import { render, staticRenderFns } from "./GroupUserForm.vue?vue&type=template&id=9d4d15fc&"
import script from "./GroupUserForm.vue?vue&type=script&lang=js&"
export * from "./GroupUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports